// src/components/FilteredTablePage.tsx
import React, { useMemo, useState } from 'react';
import { Container } from 'react-bootstrap';
import FilterComponent from './FilterComponent';
import useFetchReferentialServices from '../../hooks/useFetchReferentialServices';
import ServicesTable from './ServicesTable';
import { useTranslation } from 'react-i18next';
import { ServiceFilterCriteria } from '../../interfaces';


const ServicesPage: React.FC = () => {
  const { t } = useTranslation();
  const [filterCriteria, setFilterCriteria] = useState<ServiceFilterCriteria>({ name: '', version: '' });

  // Prepare API request parameters: strictly includes backend fields and prevents sending empty values
  const searchParams = useMemo(() => {
    const params: ServiceFilterCriteria = { name: filterCriteria.name, version: filterCriteria.version };
    if (filterCriteria.defaultExternalPort) {
      params.defaultExternalPort = filterCriteria.defaultExternalPort;
    }
    return params;
  }, [filterCriteria])

  const { apiResponse, error, refetch } = useFetchReferentialServices(searchParams);

  if (error) {
    return <div>{t("error")}: {error}</div>;
  }

  return (
    <Container>
      <FilterComponent onFilterChange={setFilterCriteria} refetch={refetch} />
      <ServicesTable servicesData={apiResponse} filterCriteria={filterCriteria} />
    </Container>
  );
};

export default ServicesPage;
